export class TradingSystemSummary {
    mercato: string = '';
    pip: number = 1;
    spread: number = 0;
    numop: number = 0;
    numopbuy: number = 0;
    numopsell: number = 0;
    numopbuypos: number = 0;
    numopsellpos: number = 0;
    numoppos: number = 0;
    percposbuy: number = 0;
    percpossell: number = 0;
    percpos: number = 0;
    puntitotbuy: number = 0;
    puntitotsell: number = 0;
    puntitot: number = 0;
    puntiopbuy: number = 0;
    puntiopsell: number = 0;
    puntiop: number = 0;
    maxprofitbuy: number = 0;
    maxprofitsell: number = 0;
    maxprofit: number = 0;
    maxlossbuy: number = 0;
    maxlosssell: number = 0;
    maxloss: number = 0;
    rawalbuy: number = 0;
    rawalsell: number = 0;
    rawal: number = 0;
    kellybuy: number = 0;
    kellysell: number = 0;
    kelly: number = 0;
    maxDD: number = 0;

    popolaDati(market: string, pip: number, dati: any[]) {
        this.mercato = market
        this.pip = pip
        this.popolaDatiTot(dati)
        this.popolaDatiBuy(dati)
        this.popolaDatiSell(dati)
        return this
    }

    private popolaDatiTot(dati: any[]) {
        this.numop = dati.length
        this.numoppos = dati.filter((el: any) => el.profit > 0).length
        this.percpos = this.numoppos / this.numop * 100
        this.puntitot = dati.reduce((a: any, b: any) => a + +b.profit, 0) / this.pip
        this.puntiop = this.puntitot / this.numop
        let d = dati.map((el: any) => el.profit)
        this.maxprofit = Math.max(...d)
        this.maxloss = Math.min(...dati.map((el: any) => el.profit))
        let sommapos = dati.reduce((a: any, b: any) => a + (b.profit > 0 ? b.profit : 0), 0)/this.pip
        this.rawal = (sommapos / this.numoppos)/((sommapos-this.puntitot)/(this.numop-this.numoppos))
        this.kelly = (this.percpos/100 - (1-this.percpos/100)/(this.rawal))
        let progr = 0
        let serieProg = dati.map((a: any) => {
          progr += a.profit
          return progr
        })
        let pMax = 0
        let serieMax = serieProg.map((a: any) => {
          pMax = a > pMax ? a : pMax
          return pMax
        })
        this.maxDD = Math.max(...serieMax.map((a: any, i: any) => a-serieProg[i]))/this.pip
      }
    
    private popolaDatiBuy(dati: any[]) {
      dati = dati.filter((el: any) => el.verso == 'buy')
        this.numopbuy = dati.length
        this.numopbuypos = dati.filter((el: any) => el.profit > 0).length
        this.percposbuy = this.numopbuypos / this.numopbuy * 100
        this.puntitotbuy = dati.reduce((a: any, b: any) => a + +b.profit, 0) / this.pip
        this.puntiopbuy = this.puntitotbuy / this.numopbuy
        this.maxprofitbuy = Math.max(...dati.map((el: any) => el.profit))
        this.maxlossbuy = Math.min(...dati.map((el: any) => el.profit))
        let sommapos = dati.reduce((a: any, b: any) => a + (b.profit > 0 ? b.profit : 0), 0)/this.pip
        this.rawalbuy = (sommapos / this.numopbuypos)/((sommapos-this.puntitotbuy)/(this.numopbuy-this.numopbuypos))
        this.kellybuy = (this.percposbuy/100 - (1-this.percposbuy/100)/(this.rawalbuy))
      }
    
      private popolaDatiSell(dati: any[]) {
        dati = dati.filter((el: any) => el.verso == 'sell')
        this.numopsell = dati.length
        this.numopsellpos = dati.filter((el: any) => el.profit > 0).length
        this.percpossell = this.numopsellpos / this.numopsell * 100
        this.puntitotsell = dati.reduce((a: any, b: any) => a + +b.profit, 0) / this.pip
        this.puntiopsell = this.puntitotsell / this.numopsell
        this.maxprofitsell = Math.max(...dati.map((el: any) => el.profit))
        this.maxlosssell = Math.min(...dati.map((el: any) => el.profit))
        let sommapos = dati.reduce((a: any, b: any) => a + (b.profit > 0 ? b.profit : 0), 0)/this.pip
        this.rawalsell = (sommapos / this.numopsellpos)/((sommapos-this.puntitotsell)/(this.numopsell-this.numopsellpos))
        this.kellysell = (this.percpossell/100 - (1-this.percpossell/100)/(this.rawalsell))
      }
}
